import { CompanySelectorBaseDataProvider } from './CompanySelectorBaseDataProvider';
import { GetCompaniesRequest, GetCompaniesResponse } from '@nirvana/shared/dtos/types/dashboards/gz-console';
import { sanitizeObject } from '../../utils/sanitization.utils';

export class CompanySelectorGzDataProvider extends CompanySelectorBaseDataProvider {
  async getCompanies(request: GetCompaniesRequest): Promise<GetCompaniesResponse | undefined> {
    try {
      const response = await this.dependencies.api.clients.Company.getAvailableCompanies(request).toPromise();
      return sanitizeObject(response);
    } catch (e) {
      throw new Error(e.message || e);
    }
  }
}
